module.exports = __webpack_public_path__ + "img/thumbnail-moon.8681388f.jpeg";